import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import NoDataFound from "../../NoDataFound";
import { TABS_TYPE_KEY, USER_TAB_TYPE } from "../../../constant/constants";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from "../../../apiClient";
import { GROUP_SETTING } from "../../../apiClient/apiEndpoints";
import { checkPermissionExist, modalName, toggleArrayByObject } from "../../../utils/general";
import { useModalContext } from "../../../modal/context/ModalProvider";
import {
  RESOURCE_REVOKE_PERMISSION,
  RESOURCE_VIEW_PERMISSION,
  USER_CREATE_PERMISSION,
  USER_MOVE_PERMISSION,
  USER_STATUS_PERMISSION,
} from "../../../constant/permission";
import { useScrollDirectionClass } from "../../ForMobile/useScrollDirectionClass";

const { GridView, GroupUserCard, PlaceholderCard, SimCheckBox, SimToggleSwitch } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const UserTab = ({
  list,
  search,
  loading,
  hasMore,
  paginationPage,
  selectedItems,
  setSelectedItems,
  handleClearSelection,
  getUsersList,
  triggerRefreshHandler,
  handleChangeLocallyStatus,
  isMobileView,
}) => {
  const { openModal } = useModalContext();
  const configData = useUnoSelector((state) => state.config);
  const params = useParams();
  const navigate = useNavigate();

  const [userList, setUserList] = useState([]);

  useScrollDirectionClass();

  useEffect(() => {
    setUserList(list);
  }, [list]);

  const loadMoreData = () => {
    getUsersList(paginationPage, search);
  };

  const handleChangeStatus = async (data) => {
    try {
      handleChangeLocallyStatus({ ids: [data.uuid], status: data.active });
      await apiClient.post(
        `${configData.config.UNO_URL}${GROUP_SETTING}/${TABS_TYPE_KEY[USER_TAB_TYPE]}/${data.uuid}`,
        {
          active: data.active,
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenUserMoveModal = (user) => {
    openModal({
      modalName: modalName.GROUP_USER_MOVE,
      params,
      type: USER_TAB_TYPE,
      transferData: [{ id: user.uuid, data: user }],
      status: true,
      handleRefreshTab: triggerRefreshHandler,
      handleClearSelection,
    });
  };

  const handleOpenUserUpdateModal = (user) => {
    navigate(`/manage/account/${user.uuid}`);
    // openModal({
    //   modalName: modalName.USER_ADD,
    //   type: "update",
    //   id: user.uuid,
    //   params,
    //   handleRefreshTab: triggerRefreshHandler,
    //   openChangePasswordModal: () => handleOpenChangePasswordModal(user)
    // })
  };

  const handleOpenChangePasswordModal = (user) => {
    openModal({
      modalName: modalName.PASSWORD_CHANGE,
      type: "update",
      UUID: user.uuid,
      params,
      user: {
        email: user.email,
      },
    });
  };

  const handleAssignAppClick = (data) => {
    let selectedData = {
      type: USER_TAB_TYPE,
      items: [{ name: data.name, uuid: data.uuid, avatar: data.avatar }],
    };
    navigate(`/resource-management/${USER_TAB_TYPE}/${params.uuid}`, { state: { selectedData } });
  };

  const handleGroupClick = (uuid) => {
    if (checkPermissionExist(RESOURCE_VIEW_PERMISSION)) {
      navigate(`/team-management/user/${uuid}`);
    }
  };

  const handleSelectItems = (data) => {
    setSelectedItems((pre) => toggleArrayByObject(pre, data));
  };

  return (
    <>
      <div id="scrollableDivUsers" className="scrollable-container">
        {loading ? (
          <PlaceholderCard circle={true} count={4} />
        ) : userList.length > 0 ? (
          <InfiniteScroll
            scrollThreshold={0.7}
            dataLength={userList.length}
            next={() => loadMoreData()}
            hasMore={hasMore}
            loader={<PlaceholderCard count={5} />}
            scrollableTarget="scrollableDivUsers"
          >
            <div className="groups-tab">
              <GridView>
                {userList.map((user, i) => {
                  const role =
                    user.roleAllocations.find((e) => e.role.type !== "DEFAULT")?.role || user.roleAllocations[0]?.role;

                  const UserDropdownItems = [
                    {
                      permission: RESOURCE_REVOKE_PERMISSION,
                      label: "Assign Application",
                      onClick: () => handleAssignAppClick(user),
                    },
                    {
                      permission: USER_CREATE_PERMISSION,
                      label: "Edit",
                      onClick: () => handleOpenUserUpdateModal(user),
                    },
                    {
                      permission: USER_STATUS_PERMISSION,
                      label: "Status",
                      component: (
                        <SimToggleSwitch
                          checked={user.active}
                          onChange={() => handleChangeStatus({ active: !user.active, uuid: user.uuid })}
                        />
                      ),
                    },
                    {
                      permission: USER_MOVE_PERMISSION,
                      label: "Move",
                      onClick: () => handleOpenUserMoveModal(user),
                    },
                  ];

                  let dropDowns = UserDropdownItems.filter((e) => checkPermissionExist(e.permission));

                  return (
                    <GroupUserCard
                      key={i}
                      Name={user.name}
                      Tag={role?.name || ""}
                      Image={user.avatar}
                      subGroup={false}
                      groupUsers={false}
                      assignedApps={false}
                      cardTypeUser={true}
                      userDes={user.designation || ""}
                      userMail={user.email}
                      editButtonEnable={checkPermissionExist(USER_CREATE_PERMISSION)}
                      onEditClick={() => handleOpenUserUpdateModal(user)}
                      onClick={() =>
                        selectedItems.length > 0
                          ? handleSelectItems({ id: user.uuid, data: user })
                          : handleGroupClick(user.uuid)
                      }
                      user_id={user.uid}
                      dropdownItems={dropDowns.length > 0 ? dropDowns : false}
                      checkbox={
                        isMobileView ? (
                          false
                        ) : (
                          <SimCheckBox
                            onChange={() => handleSelectItems({ id: user.uuid, data: user })}
                            checked={selectedItems.find((item) => item.id == user.uuid)}
                          />
                        )
                      }
                      isActive={user.active}
                    />
                  );
                })}
              </GridView>
            </div>
          </InfiniteScroll>
        ) : (
          <div className="no-data">
            <NoDataFound headText="No User found" infoText="" />
          </div>
        )}
      </div>
    </>
  );
};

export default UserTab;
